import { render, staticRenderFns } from "./OrderListView.vue?vue&type=template&id=206605b0&scoped=true&"
import script from "./OrderListView.vue?vue&type=script&lang=js&"
export * from "./OrderListView.vue?vue&type=script&lang=js&"
import style0 from "./OrderListView.vue?vue&type=style&index=0&id=206605b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206605b0",
  null
  
)

export default component.exports